import {InputState, OpenEndedQuestionState} from './classroom/models';
import {InlineOpenEndedQuestionModel, positionToItemId} from './models';

function inputItemIds(model: InlineOpenEndedQuestionModel): string[] {
  const itemIds: string[] = [];

  for (let paragraphIndex = 0; paragraphIndex < model.paragraphs.length; paragraphIndex++) {
    let paragraph = model.paragraphs[paragraphIndex];
    for (let itemIndex = 0; itemIndex < paragraph.items.length; itemIndex++) {
      let item = paragraph.items[itemIndex];
      if (item.type !== 'input')
        continue;
      const itemId = positionToItemId(paragraphIndex, itemIndex);
      itemIds.push(itemId);
    }
  }

  return itemIds;
}

function defaultInputItemState(): InputState {
  return {value: ''};
}

function initialState(model: InlineOpenEndedQuestionModel): OpenEndedQuestionState {
  const itemIds = inputItemIds(model);
  const itemStates: { [index: string]: InputState } = {};

  for (let itemId of itemIds)
    itemStates[itemId] = defaultInputItemState();

  return {
    states: itemStates
  };
}

class OpenEndedQuestionInlineUtilsClass {
  readonly initialState = initialState;
}

export const openEndedQuestionInlineUtils = new OpenEndedQuestionInlineUtilsClass();
